/**
 * Navigation buttons component
 */

import { Button, SecondaryButton } from '@ox/visits-ui/components/shared/FormComponents';

interface NavigationButtonsProps {
  currentSection: number;
  totalSections: number;
  onPrevious: () => void;
  onNext: () => void;
  onSubmit?: () => void;
  canProceed: boolean;
}

export function NavigationButtons({
  currentSection,
  totalSections,
  onPrevious,
  onNext,
  onSubmit,
  canProceed,
}: NavigationButtonsProps) {
  const isFirst = currentSection === 0;
  const isLast = currentSection === totalSections - 1;

  return (
    <div className="navigation-buttons">
      {!isFirst && <SecondaryButton onClick={onPrevious}>Previous</SecondaryButton>}

      {!isLast && (
        <Button onClick={onNext} disabled={!canProceed}>
          Continue
        </Button>
      )}

      {isLast && onSubmit && (
        <Button onClick={onSubmit} disabled={!canProceed}>
          Submit
        </Button>
      )}
    </div>
  );
}
